import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-subscription-alert',
  templateUrl: './subscription-alert.component.html',
  styleUrls: ['./subscription-alert.component.scss']
})
export class SubscriptionAlertComponent implements OnInit {

  @Input() alertData: any = null;

  constructor() { }

  ngOnInit(): void {
  }

}
